<template>
  <div class="campaign-label">
    <img
      class="icon"
      alt="icon coupon"
      :src="`${$root.cdnUrl}assets/icon-coupon.svg`"
    >
    <div class="text">
      <div>
        {{ $t('product.components.campaignLabel.title') }}
      </div>
      <span>
        <b>
          {{ product.campaignProduct.startDate | dateTime('DD.MM.YYYY') }}
          —
          {{ product.campaignProduct.endDate | dateTime('DD.MM.YYYY') }}
          {{ $t('product.components.campaignLabel.betweenDate') }}
        </b>
      </span>
      <span>
        {{ $t('product.components.campaignLabel.priceWithCampaign') }}
        <b>{{ product.campaignProduct.price | formatPrice({ suffix: '₺'}) }} </b>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CampaignLabel',
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
};
</script>
<style scoped lang="scss">
  .campaign-label {
    padding: 8px 16px 8px 8px;
    background: #FEF2E8;
    border: 1px solid #F27A1A;
    border-radius: 4px;
    display: flex;
    align-items: center;
    margin-bottom: 8px;

    ::v-deep .icon {
      width: 16px;
      height: 16px;
    }
    .text {
      margin-left: 8px !important;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      a {
        color: #F27A1A;
        text-decoration: underline;
      }
    }
  }
</style>
